import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';
import {Link as RoutedLink} from 'react-router-dom';

import {SaveButton} from 'shells/button/save-button/save-button';
import {Link} from 'shells/link/link';
import {RightFrame, ModalMain, NavButtons} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';

import {addNotification} from '../../../notifications/index';

import {useCreateKixieIntegration} from './graphql/hooks/use-create-kixie-integration';
import {useSetKixieIntegrationIsEnabled} from './graphql/hooks/use-set-kixie-integration-is-enabled';
import {KixieForm} from './kixie-form';

type Props = {
    prevPage: string;
    history: RouterHistory;
};

export function KixieSetup(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const [businessId, setBusinessId] = React.useState<string>('');
    const [apiKey, setApiKey] = React.useState<string>('');

    const hasFormValues = Boolean(businessId && apiKey);

    const {createKixieIntegration, error: errorCreating} = useCreateKixieIntegration();
    const {setKixieIntegrationIsEnabled, error: errorEnabling} = useSetKixieIntegrationIsEnabled();

    const onSubmit = () => {
        if (!hasFormValues) return;
        setIsSaving(true);
        createKixieIntegration({businessId, apiKey})
            .then(({data}) => {
                if (data && data.kixieIntegrationCreate) {
                    onSetKixieIntegrationIsEnabled();
                }
            })
            .catch(() => {
                setIsSaving(false);
                addNotification('Failed to create Kixie integration', {
                    body: 'Please try again.',
                    icon: 'frowny',
                });
            });
    };

    const onSetKixieIntegrationIsEnabled = () => {
        setIsSaving(true);
        setKixieIntegrationIsEnabled(true)
            .then(({data}) => {
                if (data && data.setKixieIntegrationIsEnabled) {
                    setIsSaving(false);
                    props.history.push(
                        '/connect-phone-integration/configure-activity-types?integrationType=KIXIE'
                    );
                }
            })
            .catch(() => {
                setIsSaving(false);
                addNotification('Failed to enable Kixie integration', {
                    body: 'Please try again.',
                    icon: 'frowny',
                });
            });
    };

    return (
        <RightFrame>
            <ModalMain fullheight={true}>
                <ModalHeader>Set up your Kixie integration</ModalHeader>
                <KixieForm
                    businessId={businessId}
                    apiKey={apiKey}
                    setBusinessId={setBusinessId}
                    setApiKey={setApiKey}
                />
            </ModalMain>
            <NavButtons>
                {/* @ts-expect-error */}
                <Link as={RoutedLink} to={props.prevPage}>
                    Back
                </Link>
                <SaveButton
                    variant='primary'
                    size='big'
                    disabled={!hasFormValues}
                    // @ts-expect-error
                    onClick={onSubmit}
                    isSaving={isSaving}
                    buttonText='Next'
                    resetOnComplete={true}
                    errorSaving={Boolean(errorCreating || errorEnabling)}
                />
            </NavButtons>
        </RightFrame>
    );
}
